import { Menu } from "lucide-react";
import { useState } from "react";
import { MobileHeaderLogo } from "./LogoVariants";
import { useAuth } from "../../context/AuthContext";
import { SidebarNav } from "./SidebarNav";
import { MobileMenuPanel } from "./MobileMenuPanel";
import QuickAddFAB from "../dashboard/QuickAddFAB";
import NotificationBell from "./NotificationBell";

export default function AppShell({ children, activePage, title }) {
  var auth = useAuth();
  var user = auth.user;
  var logout = auth.logout;
  var mobileMenuState = useState(false);
  var mobileMenuOpen = mobileMenuState[0];
  var setMobileMenuOpen = mobileMenuState[1];
  var isAdmin = user ? user.role === "admin" : false;
  var isTeamLeader = user ? user.role === "team_leader" : false;
  var isAssistant = user ? user.role === "assistant" : false;
  var viewModeState = useState((isAdmin || isTeamLeader || isAssistant) ? "gestor" : "corretor");
  var viewMode = viewModeState[0];
  var setViewMode = viewModeState[1];
  var userName = user ? user.name : "Usuario";
  var displayTitle = title || "Dashboard";

  function handleViewChange(mode) {
    if (mode === "gestor" && !isAdmin && !isTeamLeader) return;
    setViewMode(mode);
  }

  return (
    <div className="min-h-screen bg-gray-100 flex" data-testid="app-shell">
      <SidebarNav viewMode={viewMode} onViewChange={handleViewChange} user={user} isAdmin={isAdmin} onLogout={logout} activePage={activePage} />
      <MobileMenuPanel isOpen={mobileMenuOpen} onClose={function() { setMobileMenuOpen(false); }} viewMode={viewMode} onViewChange={handleViewChange} user={user} isAdmin={isAdmin} activePage={activePage} />
      <main className="flex-1 lg:ml-64 xl:ml-72">
        <header className="bg-white border-b border-gray-200 px-4 sm:px-6 lg:px-8 py-4 sticky top-0 z-10">
          <div className="flex items-center justify-between">
            <button className="lg:hidden p-2 -ml-2 text-gray-600 hover:bg-gray-100 rounded-lg" onClick={function() { setMobileMenuOpen(true); }} data-testid="mobile-menu-button">
              <Menu className="w-6 h-6" />
            </button>
            <div className="hidden sm:block">
              <h1 className="text-xl lg:text-2xl font-bold text-[#0A2F3D]">{displayTitle}</h1>
              <p className="text-sm text-gray-500">Bem-vindo de volta, {userName}</p>
            </div>
            <div className="lg:hidden"><MobileHeaderLogo /></div>
            <div className="flex items-center gap-2 sm:gap-4">
              <NotificationBell />
            </div>
          </div>
        </header>
        <div className="p-4 sm:p-6 lg:p-8">
          <div className="sm:hidden mb-4">
            <h1 className="text-xl font-bold text-[#0A2F3D] mb-1">{displayTitle}</h1>
            <p className="text-sm text-gray-500">Bem-vindo, {userName}</p>
          </div>
          {typeof children === "function" ? children({ viewMode: viewMode, handleViewChange: handleViewChange, isAdmin: isAdmin, isTeamLeader: isTeamLeader, user: user }) : children}
        </div>
      </main>
      {activePage === "painel" && <QuickAddFAB />}
    </div>
  );
}
